<template>
  <el-dialog title="更改城市" :visible.sync="editCityShow" width="1200px" v-dialogDrag @close="close">
    <div class="head">
      <el-form label-width="100px" :inline="true" size="normal">
        <el-form-item label="选择城市">
          <el-select v-model="selectedCity" placeholder="选择城市" size="mini">
            <el-option :label="city.label" :value="city.label" v-for="(city, index) in cityList" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="confirm" size="mini">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      path: '/project/article',
      editCityShow: true,
      cityList: this.$store.getters.getcitylist,
      selectedCity: '',
      id:'',
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.selectedCity = this.$route.query.city;
    if(!this.cityList.length){
      this.getCityList();
    }
  },
  methods: {
    confirm() {
        let params = {
            city:this.selectedCity,
            id:this.id,
        }
        this.$api.editCity(params).then(
            data=>{
                this.$message.success(data);
                this.$router.go(-1);
            }
        )
    },
    close() {
      this.$router.go(-1);
    },
    getCityList() {
      this.$api.getCityList("").then((data) => {
        this.cityList = data;
        this.$store.commit('setcitylist', data);
      });
    },
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #f7f7f7;
}
</style>
